<template>
  <div style="position:absolute;top:0;left:0;right:0;bottom:0;" class="layout-column">
    <tiny-progress-view :visible="isLoading" text="Importiere"></tiny-progress-view>

    <div class="layout-column flex ma-1"
         style="border-radius:4px;position:relative;"
         v-bind:style="{background: compColor.contentFrame}">

      <div class="flex pa-2" style="overflow-y: scroll;">

        <lx-expansion-panels :single-open="false" v-model="panel">

          <!-- Protokolle und Substanzen -->

          <lx-expansion-panel disabled>
            <lx-expansion-panel-header icon="mdi-database-import"
                                       :main-headline="$t('MAINTENANCE_OVERVIEW.PROTOCOLS_AND_AGENTS.HEADLINE')"
                                       :sub-headline="$t('MAINTENANCE_OVERVIEW.PROTOCOLS_AND_AGENTS.SUB_HEADLINE')"
                                       disabled>
            </lx-expansion-panel-header>
            <lx-expansion-panel-content>
              <div class="pa-4 layout-row layout-wrap">
                <div class="layout-row layout-wrap flex-100">
                  <div class="flex layout-row px-3 py-3">
                    {{ $t('MAINTENANCE_OVERVIEW.PROTOCOLS_AND_AGENTS.DESCRIPTION') }}
                  </div>
                </div>

                <div class="layout-row layout-wrap flex-100">
                  <div class="flex-15 layout-row px-3 py-3">
                    <div class="pr-2">
                      <v-btn @click="openHiddenProtocolsAndAgentsFileInput" :color="compColor.primeColor" dark class="text-none" :disabled="isLoading">
                        {{ $t("MAINTENANCE_OVERVIEW.BUTTON_UPLOAD") }}
                      </v-btn>
                    </div>

                    <input type="file" hidden ref="hiddenProtocolsAndAgentsFileInput" @change="uploadProtocolsAndAgentsFile"/>
                  </div>

                  <div class="flex layout-row layout-align-start-center" v-if="model.protocols_and_agents && model.protocols_and_agents.version">
                    {{ $t('MAINTENANCE_OVERVIEW.VERSION_UPDATE') }} {{ model.protocols_and_agents.version | formatDate }} <span class="pl-1" v-if="model.protocols_and_agents.filepath">({{ model.protocols_and_agents.filepath }})</span>
                  </div>
                </div>
              </div>
            </lx-expansion-panel-content>
          </lx-expansion-panel>

          <!-- oBDS XSD -->

          <lx-expansion-panel disabled>
            <lx-expansion-panel-header icon="mdi-database-import"
                                       :main-headline="$t('MAINTENANCE_OVERVIEW.XSD.HEADLINE')"
                                       :sub-headline="$t('MAINTENANCE_OVERVIEW.XSD.SUB_HEADLINE')"
                                       disabled>
            </lx-expansion-panel-header>
            <lx-expansion-panel-content>
              <div class="pa-4 layout-row layout-wrap">
                <div class="layout-row layout-wrap flex-100">
                  <div class="flex layout-row px-3 py-3">
                    {{ $t('MAINTENANCE_OVERVIEW.XSD.DESCRIPTION') }}
                  </div>
                </div>

                <div class="flex-gt-sm-100 flex-100 px-2">
                  <div class="pr-2">
                    <v-btn @click="openHiddenSchemaFileInput()" :color="compColor.primeColor" dark class="text-none" :disabled="isLoading">
                      {{ $t("MAINTENANCE_OVERVIEW.BUTTON_UPLOAD") }}
                    </v-btn>
                  </div>

                  <input type="file" hidden ref="hiddenSchemaFileInput" @change="uploadSchemaFile"/>
                </div>

                <div class="flex-gt-sm-100 flex-100 px-2 pb-2 pt-4">
                  <div class="flex-100">
                    <lx-data-table-simple
                      tableName="SchemaList"
                      v-model="tableObj.selection"
                      :items="model.schema"
                      :headers="tableObj.headers"
                      :loading="tableObj.loading"
                      :no-data-text="$t('NO_ROWS')"
                      :hideContextFilter="true"
                      :preventRowClick="true"
                      :setHeightOnItems="true">

                      <template #cellrenderer="{ value }">
                        <div v-if="value.f.renderer === 'delete'" style="cursor:pointer;">
                          <v-icon :color="compColor.primeColor" @click="openDeleteDialog(value.i)">mdi-delete-forever</v-icon>
                        </div>
                      </template>
                    </lx-data-table-simple>
                  </div>
                </div>
              </div>
            </lx-expansion-panel-content>
          </lx-expansion-panel>

          <!-- CTCAE -->

          <lx-expansion-panel disabled>
            <lx-expansion-panel-header icon="mdi-database-import"
                                       :main-headline="$t('MAINTENANCE_OVERVIEW.CTCAE.HEADLINE')"
                                       :sub-headline="$t('MAINTENANCE_OVERVIEW.CTCAE.SUB_HEADLINE')"
                                       disabled>
            </lx-expansion-panel-header>
            <lx-expansion-panel-content>
              <div class="pa-4 layout-row layout-wrap">
                <div class="layout-row layout-wrap flex-100">
                  <div class="flex layout-row px-3 py-3">
                    {{ $t('MAINTENANCE_OVERVIEW.CTCAE.DESCRIPTION') }}
                  </div>
                </div>

                <div class="layout-row layout-wrap flex-100">
                  <div class="flex-15 layout-row px-3 py-3">
                    <div class="pr-2">
                      <v-btn @click="openHiddenCtcaeFileInput()" :color="compColor.primeColor" dark class="text-none" :disabled="isLoading">
                        {{ $t("MAINTENANCE_OVERVIEW.BUTTON_UPLOAD") }}
                      </v-btn>
                    </div>

                    <input type="file" hidden ref="hiddenCtcaeFileInput" @change="uploadCtcaeFile"/>
                  </div>

                  <div class="flex layout-row layout-align-start-center" v-if="model.ctcae && model.ctcae.version">
                    {{ $t('MAINTENANCE_OVERVIEW.VERSION_UPDATE') }} {{ model.ctcae.version | formatDate }} <span class="pl-1" v-if="model.ctcae.filepath">({{ model.ctcae.filepath }})</span>
                  </div>
                </div>
              </div>
            </lx-expansion-panel-content>
          </lx-expansion-panel>

          <!-- Meldepflichtigen bösartigen Tumorerkrankungen -->

          <lx-expansion-panel disabled>
            <lx-expansion-panel-header icon="mdi-database-import"
                                       :main-headline="$t('MAINTENANCE_OVERVIEW.TUMOR_CODES.HEADLINE')"
                                       :sub-headline="$t('MAINTENANCE_OVERVIEW.TUMOR_CODES.SUB_HEADLINE')"
                                       disabled>
            </lx-expansion-panel-header>
            <lx-expansion-panel-content>
              <div class="pa-4 layout-row layout-wrap">
                <div class="layout-row layout-wrap flex-100">
                  <div class="flex layout-row px-3 py-3">
                    {{ $t('MAINTENANCE_OVERVIEW.TUMOR_CODES.DESCRIPTION') }}
                  </div>
                </div>

                <div class="layout-row layout-wrap flex-100">
                  <div class="flex-15 layout-row px-3 py-3">
                    <div class="pr-2">
                      <v-btn @click="openHiddenPrimaryTumorCodesFileInput()" :color="compColor.primeColor" dark class="text-none" :disabled="isLoading">
                        {{ $t("MAINTENANCE_OVERVIEW.BUTTON_UPLOAD") }}
                      </v-btn>
                    </div>

                    <input type="file" hidden ref="hiddenPrimaryTumorCodesFileInput" @change="uploadPrimaryTumorCodesFile"/>
                  </div>

                  <div class="flex layout-row layout-align-start-center" v-if="model.cancer_icd && model.cancer_icd.version">
                    {{ $t('MAINTENANCE_OVERVIEW.VERSION_UPDATE') }} {{ model.cancer_icd.version | formatDate }} <span class="pl-1" v-if="model.cancer_icd.filepath">({{ model.cancer_icd.filepath }})</span>
                  </div>
                </div>
              </div>
            </lx-expansion-panel-content>
          </lx-expansion-panel>

          <!-- Weiteren Klassifikationen -->

          <lx-expansion-panel disabled>
            <lx-expansion-panel-header icon="mdi-database-import"
                                       :main-headline="$t('MAINTENANCE_OVERVIEW.CLASSIFICATIONS.HEADLINE')"
                                       :sub-headline="$t('MAINTENANCE_OVERVIEW.CLASSIFICATIONS.SUB_HEADLINE')"
                                       disabled>
            </lx-expansion-panel-header>
            <lx-expansion-panel-content>
              <div class="pa-4 layout-row layout-wrap">
                <div class="layout-row layout-wrap flex-100">
                  <div class="flex layout-row px-3 py-3">
                    {{ $t('MAINTENANCE_OVERVIEW.CLASSIFICATIONS.DESCRIPTION') }}
                  </div>
                </div>

                <div class="layout-row layout-wrap flex-100">
                  <div class="flex-15 layout-row px-3 py-3">
                    <div class="pr-2">
                      <v-btn @click="openHiddenClassificationsFileInput()" :color="compColor.primeColor" dark class="text-none" :disabled="isLoading">
                        {{ $t("MAINTENANCE_OVERVIEW.BUTTON_UPLOAD") }}
                      </v-btn>
                    </div>

                    <input type="file" hidden ref="hiddenClassificationsFileInput" @change="uploadClassificationsFile"/>
                  </div>

                  <div class="flex layout-row layout-align-start-center" v-if="model.classifications && model.classifications.version">
                    {{ $t('MAINTENANCE_OVERVIEW.VERSION_UPDATE') }} {{ model.classifications.version | formatDate }} <span class="pl-1" v-if="model.classifications.filepath">({{ model.classifications.filepath }})</span>
                  </div>
                </div>
              </div>
            </lx-expansion-panel-content>
          </lx-expansion-panel>

        </lx-expansion-panels>

      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'MaintenanceOverview',
  data () {
    return {
      panel: [0, 1, 2, 3, 4],
      isLoading: false,
      model: {
        schema: []
      },
      tableObj: {
        loading: false,
        headers: [
          {
            text: '',
            width: '55px',
            renderer: 'delete'
          },
          {
            text: this.$t('MAINTENANCE_OVERVIEW.XSD.TABLE.TYPE'),
            value: 'type',
            width: '200px'
          },
          {
            text: this.$t('MAINTENANCE_OVERVIEW.XSD.TABLE.VERSION'),
            value: 'version',
            width: '100px'
          },
          {
            text: this.$t('MAINTENANCE_OVERVIEW.XSD.TABLE.LAST_MODIFIED'),
            value: 'last_modified',
            renderer: 'date',
            width: '200px'
          },
          {
            text: this.$t('MAINTENANCE_OVERVIEW.XSD.TABLE.FILEPATH'),
            value: 'filepath'
          }
        ]
      }
    }
  },
  created () {
    this.getGuidVersionData()
  },
  methods: {
    /**
     * Protocols & Register Agents
     */
    openHiddenProtocolsAndAgentsFileInput () {
      this.$refs.hiddenProtocolsAndAgentsFileInput.click()
    },

    uploadProtocolsAndAgentsFile () {
      const file = this.$refs.hiddenProtocolsAndAgentsFileInput

      if (file && file.files.length > 0) {
        if (this.isLoading) return
        this.isLoading = true

        let formData = new FormData()
        formData.append('file', file.files[0])

        axios.post('/maintenance/protocolsAndAgents', formData, { headers: { 'content-type': 'multipart/form-data' } })
          .then(() => {
            this.NotifySuccess({}, this.$t('MAINTENANCE_OVERVIEW.PROTOCOLS_AND_AGENTS.SUCCESS'))
            this.getGuidVersionData()
          })
          .catch(this.NotifyError)
          .finally(() => {
            this.isLoading = false

            //reset file input
            if (this.$refs['hiddenProtocolsAndAgentsFileInput']) {
              this.$refs['hiddenProtocolsAndAgentsFileInput'].value = ''
            }
          })
      }
    },

    /**
     * Schema
     */
    openHiddenSchemaFileInput () {
      this.$refs.hiddenSchemaFileInput.click()
    },

    uploadSchemaFile () {
      const file = this.$refs.hiddenSchemaFileInput

      if (file && file.files.length > 0) {
        if (this.isLoading) return
        this.isLoading = true

        let formData = new FormData()
        formData.append('schemaFile', file.files[0])

        axios.post('/maintenance/schema', formData, { headers: { 'content-type': 'multipart/form-data' } })
          .then(() => {
            this.NotifySuccess({}, this.$t('MAINTENANCE_OVERVIEW.XSD.SUCCESS'))
            this.getGuidVersionData()
          })
          .catch(this.NotifyError)
          .finally(() => {
            this.isLoading = false

            // reset file input
            if (this.$refs['hiddenSchemaFileInput']) {
              this.$refs['hiddenSchemaFileInput'].value = ''
            }
          })
      }
    },

    openDeleteDialog (params) {
      this.DialogConfirm(
        this.$t('CONFIRM_DELETE_DIALOG.HEADER'),
        this.$t('CONFIRM_DELETE_DIALOG.MESSAGE_DELETE_FORM'),
        { ok: this.$t('buttons.delete.value'), cancel: this.$t('buttons.cancel.value') })
        .then(() => {
          this.$http.delete('/maintenance/schema/' + params._id)
            .then(() => {
              this.getGuidVersionData()
            })
            .catch(this.NotifyError)
        })
        .catch(() => {
          // nothing to do
        })
    },

    /**
     * Ctcae
     */
    openHiddenCtcaeFileInput () {
      this.$refs.hiddenCtcaeFileInput.click()
    },

    uploadCtcaeFile () {
      const file = this.$refs.hiddenCtcaeFileInput

      if (file && file.files.length > 0) {
        if (this.isLoading) return
        this.isLoading = true

        let formData = new FormData()
        formData.append('file', file.files[0])

        axios.post('/ctcae/upload', formData, { headers: { 'content-type': 'multipart/form-data' } })
          .then(() => {
            this.NotifySuccess({}, this.$t('MAINTENANCE_OVERVIEW.CTCAE.SUCCESS'))
            this.getGuidVersionData()
          })
          .catch(this.NotifyError)
          .finally(() => {
            this.isLoading = false

            // reset file input
            if (this.$refs['hiddenCtcaeFileInput']) {
              this.$refs['hiddenCtcaeFileInput'].value = ''
            }
          })
      }
    },

    /**
     * PrimaryTumorCodes
     */
    openHiddenPrimaryTumorCodesFileInput () {
      this.$refs.hiddenPrimaryTumorCodesFileInput.click()
    },

    uploadPrimaryTumorCodesFile () {
      const file = this.$refs.hiddenPrimaryTumorCodesFileInput

      if (file && file.files.length > 0) {
        if (this.isLoading) return
        this.isLoading = true

        let formData = new FormData()
        formData.append('file', file.files[0])

        axios.post('/register/upload', formData, { headers: { 'content-type': 'multipart/form-data' } })
          .then(() => {
            this.NotifySuccess({}, this.$t('MAINTENANCE_OVERVIEW.TUMOR_CODES.SUCCESS'))
            this.getGuidVersionData()
          })
          .catch(this.NotifyError)
          .finally(() => {
            this.isLoading = false

            // reset file input
            if (this.$refs['hiddenPrimaryTumorCodesFileInput']) {
              this.$refs['hiddenPrimaryTumorCodesFileInput'].value = ''
            }
          })
      }
    },

    /**
     * Further Classifications
     */
    openHiddenClassificationsFileInput () {
      this.$refs.hiddenClassificationsFileInput.click()
    },

    uploadClassificationsFile () {
      const file = this.$refs.hiddenClassificationsFileInput

      if (file && file.files.length > 0) {
        if (this.isLoading) return
        this.isLoading = true

        let formData = new FormData()
        formData.append('file', file.files[0])

        axios.post('/classifications/upload', formData, { headers: { 'content-type': 'multipart/form-data' } })
          .then(() => {
            this.NotifySuccess({}, this.$t('MAINTENANCE_OVERVIEW.CLASSIFICATIONS.SUCCESS'))
            this.getGuidVersionData()
          })
          .catch(this.NotifyError)
          .finally(() => {
            this.isLoading = false

            // reset file input
            if (this.$refs['hiddenClassificationsFileInput']) {
              this.$refs['hiddenClassificationsFileInput'].value = ''
            }
          })
      }
    },

    /**
     * Common
     */
    getGuidVersionData () {
      this.$http.get('/maintenance/getGuidData')
        .then(res => {
          if (res.data) {
            this.model = res.data
            this.model.schema = res.data.schema || []
          }
        })
        .catch(this.NotifyError)
    }
  },
  watch: {
    '$route' (to) {
      if (to.name === 'MaintenanceOverview') {
        this.getGuidVersionData()
      }
    }
  }
}
</script>
